import { useContext } from "react";
import { AppContext } from "../App";

import banner6 from "../assets/banner6.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner5 from "../assets/banner5.jpg";
import Footer from "../ones/Footer";

export default function ServiceDetail() {
  const appContext = useContext(AppContext);
  const key = appContext.navSubItem;

  const services = {
    "building-construction": {
      title: "Building Construction",
      intro:
        "We deliver high-quality building projects that meet modern standards of safety, durability, and functionality.",
      image: banner3,
      description: [
        "Our building construction services cover commercial buildings, residential housing, office complexes, and warehouses. We apply proven construction methodologies combined with strict quality control to ensure every structure is delivered to specification.",
        "From project initiation to final handover, we prioritize safety, efficiency, and compliance with regulatory requirements, ensuring long-term value for clients and end users.",
      ],
    },

    "civil-engineering": {
      title: "Civil Engineering Works",
      intro:
        "Comprehensive civil engineering solutions designed to support infrastructure development and sustainability.",
      image: banner2,
      description: [
        "We execute civil engineering works including road construction and rehabilitation, drainage systems, culverts, bridge works, and bulk earthworks. Each project is managed with technical precision and environmental consideration.",
        "Our experienced engineers ensure structural integrity, cost control, and timely delivery while meeting national standards and client expectations.",
      ],
    },

    rehabilitation: {
      title: "Rehabilitation & Renovation",
      intro:
        "Restoring and upgrading existing structures to improve safety, performance, and aesthetic value.",
      image: banner5,
      description: [
        "Our rehabilitation and renovation services include structural repairs, building upgrades, remodeling, and finishes. We assess existing conditions thoroughly before implementing effective improvement solutions.",
        "The goal is to extend asset lifespan, enhance functionality, and ensure compliance with current building standards while minimizing operational disruption.",
      ],
    },

    maintenance: {
      title: "Routine Maintenance",
      intro:
        "Planned maintenance services that protect assets and preserve long-term operational value.",
      image: banner6,
      description: [
        "We provide routine building and road maintenance, landscaping, site improvements, and compound works to ensure assets remain safe and functional.",
        "Through proactive maintenance strategies, we help clients reduce repair costs, prevent deterioration, and maintain consistent service performance.",
      ],
    },
  };

  const svc = services[key];
  if (!svc) return null;

  return (
    <div className="MainBodySection">
      <div className="container mb-5">
        <div className="row justify-content-center">

          {/* Header */}
          <div className="col-md-12 text-center mb-4">
            <h6 className="main-section-title">{svc.title}</h6>
            <p
              className="text-dim"
              style={{ maxWidth: "850px", margin: "0 auto" }}
            >
              {svc.intro}
            </p>
          </div>

          {/* Content Card */}
          <div className="col-12">
            <div className="bg-light rounded-4 p-3 p-md-4">
              <div className="row align-items-center">
                <div className="col-md-5 mb-3 mb-md-0">
                  <img
                    src={svc.image}
                    alt={svc.title}
                    className="img-fluid rounded-3"
                  />
                </div>

                <div className="col-md-7">
                  <p className="text-dim">{svc.description[0]}</p>
                  <p className="text-dim mb-0">{svc.description[1]}</p>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="col-md-12 text-center mt-5">
            <button
              className="btn btn-primary btn-padded rounded-pill"
              onClick={() => appContext.navTo({ item: "contact_us" })}
            >
              Contact Us
            </button>
          </div>

        </div>
      </div>
      <Footer/>
    </div>
  );
}
